// Central content + navigation data for Bharat Ethanol Forum 2026

export const EVENT = {
  name: "Bharat Ethanol Forum",
  year: "2026",
  tagline: "Fuelling Bharat. Powering Growth",
  descriptor: "India's Ethanol Economy & Biofuel Leadership Forum",
  dates: "28–29 September 2026",
  datesShort: "28–29 Sep 2026",
  venue: "Westin Powai Lake, Mumbai",
  city: "Mumbai",
  expo: "Ethanol & Biofuels Trade & Tech Expo 2026",
  organiser: "Tefla's",
  email: "events@teflas.com",
  phone: "+91 98338 55566",
  phone2: "+91 98337 55566",
  address: "301 AB & 308, Abhishek Premises, C-5 Dalia Industrial Estate, Off New Link Road, Andheri (W), Mumbai – 400053, India",
  lastUpdated: "June 2026",
  logo: "/assets/bharat-ethanol-forum-logo.png",
};

export const NAV = [
  { label: "About", to: "/about" },
  {
    label: "Conference",
    to: "/conference",
    children: [
      { label: "Overview", to: "/conference" },
      { label: "Agenda", to: "/conference/agenda" },
      { label: "Speakers", to: "/conference/speakers" },
      { label: "Awards", to: "/awards" },
      { label: "Download Brochure", action: "brochure" },
      { label: "Sponsorship Proposal", action: "rateCard" },
    ],
  },
  { label: "Expo", to: "/expo" },
  {
    label: "Get Involved",
    to: "/attend",
    children: [
      { label: "Attend", to: "/attend" },
      { label: "Sponsor", to: "/sponsor" },
      { label: "Exhibit", to: "/exhibit" },
      { label: "Venue & Travel", to: "/venue" },
    ],
  },
  { label: "Calculator", to: "/ethanol-impact-calculator" },
  { label: "Insights", to: "/insights" },
];

export const FOOTER_COLS = [
  {
    title: "Ethanol Intelligence",
    links: [
      { label: "Ethanol in India", to: "/ethanol-india" },
      { label: "Ethanol Market", to: "/ethanol-market-india" },
      { label: "Ethanol Prices", to: "/ethanol-prices-india" },
      { label: "Ethanol Policy", to: "/ethanol-policy-india" },
      { label: "Biofuels in India", to: "/biofuels-india" },
      { label: "Sustainable Aviation Fuel", to: "/sustainable-aviation-fuel-india" },
    ],
  },
  {
    title: "Feedstocks",
    links: [
      { label: "Sugar Ethanol", to: "/sugar-ethanol-india" },
      { label: "Grain Ethanol", to: "/grain-ethanol-india" },
      { label: "Maize Ethanol", to: "/maize-ethanol-india" },
      { label: "Flex-Fuel Vehicles", to: "/flex-fuel-vehicles-india" },
    ],
  },
  {
    title: "Event",
    links: [
      { label: "About", to: "/about" },
      { label: "Conference", to: "/conference" },
      { label: "Expo", to: "/expo" },
      { label: "Awards", to: "/awards" },
      { label: "Venue & Travel", to: "/venue" },
    ],
  },
  {
    title: "Get Involved",
    links: [
      { label: "Attend", to: "/attend" },
      { label: "Sponsor", to: "/sponsor" },
      { label: "Exhibit", to: "/exhibit" },
      { label: "Register", to: "/register" },
    ],
  },
  {
    title: "Resources",
    links: [
      { label: "Insights", to: "/insights" },
      { label: "Impact Calculator", to: "/ethanol-impact-calculator" },
      { label: "Contact", to: "/contact" },
      { label: "Privacy", to: "/privacy" },
      { label: "Terms", to: "/terms" },
      { label: "Refunds", to: "/refund-policy" },
    ],
  },
];

export const HOME_STATS = [
  { value: 20, suffix: "%", label: "ethanol now blended in India's petrol (E20, hit in 2025 — five years early)" },
  { value: 10, prefix: "~", suffix: "×", label: "growth in ethanol capacity since 2014 (under 2 to nearly 20 billion litres)" },
  { value: 1.18, prefix: "₹", suffix: " lakh cr", decimals: 2, label: "paid to farmers through ethanol procurement" },
  { value: 380, suffix: "+", label: "distilleries now operating across India" },
];

export const WHO_ATTENDS = [
  "Sugar & ethanol producers",
  "Grain processors",
  "Oil marketing companies",
  "Automakers (flex-fuel)",
  "Distillery tech & EPC",
  "Investors, banks & funds",
  "Government & policymakers",
  "Global biofuel companies",
];

export const TIMELINE = [
  { tag: "2025", title: "E20 achieved", note: "20% blending hit five years early" },
  { tag: "Next", title: "E25 / E27", note: "Intermediate blends roll forward" },
  { tag: "May 2026", title: "E30 notified", note: "IS 19850:2026 fuel standards" },
  { tag: "Beyond", title: "Flex-fuel & SAF", note: "Vehicles, aviation, 2G & CBG" },
];

export const AGENDA_DAY1 = [
  { time: "08:30", session: "Registration & Networking Tea", focus: "" },
  { time: "10:00", session: "Business Session 1", focus: "India's Ethanol Economy: Post-E20 Growth" },
  { time: "11:30", session: "Inaugural Session", focus: "Fuelling India's Energy Transition" },
  { time: "13:00", session: "Networking Lunch", focus: "" },
  { time: "14:30", session: "Business Session 2", focus: "Feedstock Revolution: Sugar, Grain, Maize, Rice & 2G" },
  { time: "15:45", session: "Business Session 3", focus: "Flex-Fuel Vehicles, OMC Demand & Blending Economics" },
  { time: "17:00", session: "CEO Roundtable", focus: "Investing in Ethanol Infrastructure" },
  { time: "17:30", session: "Networking & Expo Visit", focus: "" },
  { time: "19:30", session: "Bharat Ethanol Leadership Awards", focus: "Gala Dinner & Entertainment" },
];

export const AGENDA_DAY2 = [
  { time: "10:00", session: "Business Session 4", focus: "Global Ethanol Markets & Trade" },
  { time: "11:15", session: "Business Session 5", focus: "Beyond Ethanol: SAF, Bio-methanol, CBG" },
  { time: "12:15", session: "Closing Leadership Session", focus: "India Ethanol Vision 2030 Declaration" },
  { time: "13:00", session: "Networking Lunch", focus: "" },
];

export const AWARD_CATEGORIES = [
  "Ethanol Producer of the Year",
  "Grain Ethanol Leader",
  "Sugar Ethanol Pioneer",
  "2G Ethanol Innovation",
  "Technology Provider",
  "Ethanol Investment",
  "Sustainability in Biofuels",
  "Emerging Ethanol Company",
  "Global Ethanol Leader",
  "Lifetime Contribution",
];

export const EXPO_EXHIBITORS = [
  "Ethanol plant & 2G technology", "Bio-refinery engineering", "Distillery equipment",
  "Fermentation", "Enzymes & yeast", "Automation & digital", "Storage & logistics",
  "Water & ZLD", "EPC & engineering", "Boilers & power", "Feedstock handling",
  "Carbon reduction", "SAF & advanced biofuels",
];

export const EXPO_VISITORS = [
  "Sugar mills & distilleries", "Grain ethanol producers", "Oil marketing companies",
  "Project developers", "Investors & funds", "Policymakers", "Traders",
  "Engineering firms", "Biomass aggregators", "Airlines exploring SAF", "Industrial ethanol buyers",
];

export const PASSES = [
  { name: "Conference Pass", price: "from ₹15,000 + GST · $300", desc: "Full 2-day conference + expo access + lunches & networking.", popular: false },
  { name: "Delegate + 1 Night Stay", price: "from ₹30,000 + GST · $600", desc: "Conference pass + 1 night at Westin Powai Lake, Mumbai.", popular: true },
  { name: "Delegate + 2 Nights Stay", price: "from ₹44,000 + GST · $820", desc: "Conference pass + 2 nights at Westin Powai Lake, Mumbai.", popular: false },
];

export const SPONSOR_TIERS = [
  { tier: "Title Partner", best: "Market leaders", includes: "Top billing, keynote slot, premium branding across forum + expo + awards, prime stall, delegate passes", invest: "On request", highlight: false },
  { tier: "Platinum", best: "Major producers / tech", includes: "Branding, speaking slot, large stall, passes, awards-night presence", invest: "On request", highlight: true },
  { tier: "Gold", best: "Growth brands", includes: "Branding, session association, stall, passes", invest: "On request", highlight: false },
  { tier: "Associate / Awards / Gala", best: "Targeted visibility", includes: "Category branding, awards or gala association", invest: "On request", highlight: false },
];

export const STALLS = [
  { name: "Exhibition Stall — 9 Sq.m", desc: "Prime, larger footprint on the expo floor, fully built.", meta: "from ₹2,00,000 + GST · $3,000", highlight: true },
  { name: "Exhibition Stall — 6 Sq.m", desc: "Compact built stall on the expo floor.", meta: "from ₹1,50,000 + GST · $2,000", highlight: false },
  { name: "Custom / Raw Space", desc: "Bespoke footprint for larger custom builds.", meta: "On request", highlight: false },
];

// Delegate registration tariff — three pricing windows, by category.
// inr/usd arrays are [Early Bird, Standard, Spot]. GST (18%) applies to INR only.
export const REG_TARIFF = {
  conference: { label: "Conference Pass", sub: "2-day conference + expo access + lunches & networking", inr: [10000, 12500, 15000], usd: [200, 300, 400] },
  stay1: { label: "Delegate + 1 Night Stay", sub: "Conference pass + 1 night at Westin Powai Lake, Mumbai", inr: [25000, 27500, 30000], usd: [500, 600, 700] },
  stay2: { label: "Delegate + 2 Nights Stay", sub: "Conference pass + 2 nights at Westin Powai Lake, Mumbai", inr: [40000, 42500, 45000], usd: [720, 820, 920] },
};

export const REG_WINDOW_LABELS = [
  { label: "Early Bird", note: "till 31 Jul 2026", end: "2026-07-31T23:59:59+05:30" },
  { label: "Standard", note: "till 15 Aug 2026", end: "2026-08-15T23:59:59+05:30" },
  { label: "Spot", note: "after 15 Aug 2026", end: "2026-09-28T10:00:00+05:30" },
];

// Squad / group discount tiers — auto-applied based on quantity.
// discount is a percentage off the gross (pre-GST) subtotal.
export const GROUP_TIERS = [
  { key: "solo",      label: "Solo",      min: 1, max: 1,   discount: 0,  hint: "1 delegate" },
  { key: "duo",       label: "Duo",       min: 2, max: 2,   discount: 15, hint: "2 delegates" },
  { key: "squad",     label: "Squad",     min: 3, max: 3,   discount: 20, hint: "3 delegates" },
  { key: "crew",      label: "Crew",      min: 4, max: 4,   discount: 25, hint: "4 delegates" },
  { key: "boardroom", label: "Boardroom", min: 5, max: 999, discount: 30, hint: "5+" },
];

export function getGroupTier(qty) {
  const n = Math.max(1, Number(qty) || 1);
  for (const t of GROUP_TIERS) if (n >= t.min && n <= t.max) return t;
  return GROUP_TIERS[0];
}

export function nextGroupTier(qty) {
  const cur = getGroupTier(qty);
  const idx = GROUP_TIERS.findIndex((t) => t.key === cur.key);
  return idx < GROUP_TIERS.length - 1 ? GROUP_TIERS[idx + 1] : null;
}

export function currentRegWindow(now = new Date()) {
  const jul31 = new Date("2026-07-31T23:59:59+05:30");
  const aug15 = new Date("2026-08-15T23:59:59+05:30");
  if (now <= jul31) return 0;
  if (now <= aug15) return 1;
  return 2;
}

export const COUNTRIES = ["India", "United States", "Brazil", "United Arab Emirates", "Singapore", "United Kingdom", "Germany", "Other"];
export const ROLES = ["Producer", "Oil Marketing Company", "Automaker", "Technology Provider", "Investor / Fund", "Government / Policy", "Trader", "Consultant", "Media", "Student", "Other"];
